// Official ZERAMI landing content (Italian). Texts sourced from ZERAMI_Testi_Landing.txt.

export const COMPANY = {
  brand: "ZERAMI",
  legalName: "Montoro Advisors S.r.l.",
  marchio: "Esclusivista del marchio ZERAMI",
  address: "Via Venti Settembre, 118 — 00187 Roma (RM)",
  piva: "18551871009",
  rea: "RM-1791972",
  pec: "montoroadvisorssrl@pec.it",
  email: "info@zerami.it",
  privacyEmail: "privacy@zerami.it",
  capitale: "€ 10.000,00 i.v.",
  phone: "06 9291 8511",
  phoneHref: "tel:+390692918511",
  emailHref: "mailto:info@zerami.it",
  playStore: "https://play.google.com/store/apps/details?id=com.zerami.app",
  codiceEticoUrl: "https://saldo-stralcio-calc.emergent.host/api/static/deliverables/landing_assets/ZERAMI_Codice_Etico.pdf",
  fonteMinistero:
    "https://datiestatistiche.giustizia.it/it/dettaglio_dashboard-occ.page?contentId=TGR10412",
};

export const HERO = {
  eyebrow: "LA SOLUZIONE AI TUOI DEBITI",
  title: "Cancellare i debiti si può",
  subtitle:
    "Procedure di sovraindebitamento e saldo e stralcio. Un percorso legale, riservato e concreto per liberarti dal peso dei debiti.",
  primaryCta: "CHIEDI CONSULENZA GRATUITA",
  appCta: "SCARICA L'APP",
};

export const TRUST_BADGES = [
  { icon: "ShieldCheck", title: "DATI ANONIMI", text: "Nessun dato personale condiviso" },
  { icon: "FileCheck2", title: "ZERO DOCUMENTI", text: "Compila in 2 minuti" },
  { icon: "PhoneCall", title: "TI RICHIAMIAMO", text: "Consulenza gratuita" },
];

export const STAT = {
  kicker: "TAGLIA I TUOI DEBITI",
  value: "FINO ALL'87%",
  source: "Fonte: Ministero della Giustizia (dati 2024)",
  note:
    "In media, secondo dati ufficiali del Ministero della Giustizia — Procedure di Sovraindebitamento ex Legge 3/2012 e successivo Codice della Crisi d'Impresa (D.Lgs. 14/2019).",
  disclaimer:
    "Per il saldo e stralcio il taglio effettivo dei debiti dipende dalla disponibilità economica del debitore e dalla volontà dei creditori di accettare la proposta. Ogni pratica è valutata caso per caso.",
};

export const CTA_BAND = {
  title: "Inizia Ora - È Gratis",
  subtitle: "Un consulente ti contatterà entro 24 ore",
  primary: "RICHIEDI CONSULENZA",
  app: "SCARICA L'APP",
};

export const PAIN = {
  title: "Ti riconosci in questa situazione?",
  items: [
    { icon: "CreditCard", text: "Rate del mutuo o prestiti che non riesci più a pagare" },
    { icon: "MailWarning", text: "Lettere di sollecito e minacce di pignoramento" },
    { icon: "Frown", text: "Ansia e stress per la situazione finanziaria" },
    { icon: "Home", text: "Paura di perdere la casa o l'auto" },
  ],
  outro1: "Non sei solo. Migliaia di italiani vivono la stessa situazione.",
  outro2: "Ma esiste una via d'uscita legale.",
};

export const LEGAL = {
  title: "La Legge è dalla tua parte",
  subtitle: 'D.Lgs. 14/2019 — Codice della Crisi d\'Impresa (Ex Legge 3/2012 "Salva Suicidi")',
  services: [
    { icon: "HeartHandshake", name: "Salva Suicidi", text: "Esdebitazione: liberazione dai debiti residui prevista dalla legge per chi non può più pagare." },
    { icon: "Scale", name: "Piano di Ristrutturazione", text: "Riduci i tuoi debiti e paga solo quello che puoi realmente permetterti." },
    { icon: "Handshake", name: "Saldo e Stralcio", text: "Negoziamo con i creditori per chiudere i debiti a una somma ridotta." },
    { icon: "ShieldOff", name: "Stop Pignoramenti", text: "Blocchiamo le azioni esecutive e proteggiamo i tuoi beni nei modi previsti dalla legge." },
  ],
};

export const COSTS = {
  title: "TRASPARENZA SUI COSTI",
  subtitle: "Nessuna sorpresa: ti spieghiamo con chiarezza come funzionano i costi, prima di ogni incarico.",
  blocks: [
    {
      name: "Saldo e Stralcio",
      tagline: "Negoziazione stragiudiziale con i creditori",
      items: [
        {
          n: "1",
          title: "Istruttoria iniziale",
          text: "È un'obbligazione di mezzi, dovuta per il lavoro di analisi della posizione debitoria, a prescindere dall'esito della trattativa.",
        },
        {
          n: "2",
          title: "Compenso a risultato",
          text: "Una quota calcolata sull'importo accettato a saldo. Definito e dovuto SOLO dopo l'accettazione dell'accordo da parte del creditore.",
        },
      ],
      note: "Si tratta di un'obbligazione di mezzi e non di risultato: non garantiamo alcuna percentuale di riduzione del debito, poiché l'esito dipende dalla libera accettazione del creditore.",
    },
    {
      name: "Sovraindebitamento",
      tagline: "Legge 3/2012 · Codice della Crisi",
      items: [
        {
          n: "1",
          title: "Istruttoria iniziale",
          text: "Copre l'apertura pratica e la verifica di ammissibilità alla procedura. È un'obbligazione di mezzi dovuta per l'attività di analisi.",
        },
        {
          n: "2",
          title: "Costo della procedura",
          text: "Comprende i compensi dell'OCC e/o del Gestore della Crisi nominato dal Tribunale e l'assistenza legale. Ai clienti della rete ZERAMI viene applicato uno sconto del 40% sul preventivo dell'assistenza legale.",
        },
      ],
      note: "Si tratta di un'obbligazione di mezzi e non di risultato: l'ammissione e l'esito della procedura dipendono dall'OCC e dal Tribunale competente.",
    },
  ],
};

export const SERVICE_NAMES = {
  sovraindebitamento: "Sovraindebitamento (Legge 3/2012)",
  saldo_stralcio: "Accordi Saldo e Stralcio",
};

export const CONSENTS = [
  { key: "informativa_presa_visione", required: true, label: "Presa visione dell'Informativa (Art. 13 GDPR)" },
  { key: "dati_personali", required: true, label: "Trattamento Dati Personali (Art. 6.1.b GDPR)" },
  { key: "dati_particolari_art9", required: true, label: "Trattamento Dati Particolari (Art. 9 GDPR)" },
  { key: "dati_giudiziari_art10", required: true, label: "Trattamento Dati Giudiziari (Art. 10 GDPR)" },
  { key: "marketing_profilazione", required: false, label: "Marketing e Profilazione (Art. 6.1.a GDPR) — facoltativo" },
];

// AGCM / consumer-protection compliance note.
export const DISCLAIMER_AGCM =
  "Informazioni ai sensi del Codice del Consumo (D.Lgs. 206/2005) e delle indicazioni AGCM. ZERAMI (Montoro Advisors S.r.l.) svolge attività di consulenza e assistenza al debitore per l'accesso agli strumenti previsti dalla Legge 3/2012 e dal Codice della Crisi (D.Lgs. 14/2019) e alla negoziazione stragiudiziale (saldo e stralcio). Non svolgiamo recupero crediti né intermediazione creditizia o finanziaria. Le prestazioni costituiscono obbligazione di mezzi e non di risultato: nessun esito è garantito a priori. Costi, tempi e condizioni sono comunicati in modo chiaro e trasparente prima del conferimento dell'incarico.";

// Social/meta-safe overrides for the /adv/{code} campaign landing (no percentages, no fear leverage).
export const SOCIAL = {
  heroEyebrow: "SOLUZIONI LEGALI PER LA TUA SITUAZIONE DEBITORIA",
  heroTitle: "Gestire e ridurre i debiti si può, con la legge",
  statKicker: "RIDUCI E RINEGOZIA I TUOI DEBITI",
  statValue: "Riduzioni previste dalle procedure di legge",
  painItems: [
    "Difficoltà a sostenere rate di mutuo o prestiti",
    "Solleciti di pagamento da gestire",
    "Vuoi fare chiarezza sulla tua situazione finanziaria",
    "Vuoi tutelare i tuoi beni nei modi previsti dalla legge",
  ],
  serviceNames: {
    "Salva Suicidi": "Esdebitazione (Legge 3/2012 e Codice della Crisi)",
    "Saldo e Stralcio": "Accordo di saldo e stralcio",
    "Stop Pignoramenti": "Gestione delle procedure esecutive",
  },
};
